import './scss/index.scss';
import { dcFactory } from 'dc';
import DonationFormComponent from './js/donation-form.component.js';

dcFactory.register(DonationFormComponent);
